import { queryCache, useQuery } from "react-query"
import { fetchMediaFieldsSemantics } from "api/globalMediaTypes"
import { MediaFieldSemantic } from "routes/Base/Admin/GlobalMediaTypes/types"

export function useGetSemanticName() {
  const cached = queryCache.getQueryData<MediaFieldSemantic[] | undefined>(
    "media-fields-semantics",
  )
  // ** fetch media types semantics
  const { data: fieldsSemantics } = useQuery(
    ["media-fields-semantics"],
    fetchMediaFieldsSemantics,
    {
      enabled: !cached,
      initialData: cached,
      refetchOnMount: !cached,
    },
  )

  const getSemanticName = (code?: string) =>
    fieldsSemantics?.find((s) => s?.code === code)?.name

  return { getSemanticName }
}
